<template>
  <div id="app" :class="platformType" :style="{'--primaryColor': primaryColor, '--lightColor': lightColor}">
    <router-view/>
    <el-dialog title="密码已过期，请修改密码"
               :visible="passwordExpirationInfo && passwordExpirationInfo.passwordExpireType === 'expired'"
               width="400px"
               :show-close="false">
      <el-form ref="modifyPasswordForm"
               :model="modifyPassword.form"
               :rules="modifyPassword.rules"
               size="mini">
        <el-form-item prop="oldPwd">
          <el-input type="password" v-model="modifyPassword.form.oldPwd" placeholder="输入原密码"/>
        </el-form-item>
        <el-form-item prop="newPwd">
          <el-input type="password" v-model="modifyPassword.form.newPwd" placeholder="输入新密码"/>
        </el-form-item>
        <el-form-item prop="confirmPwd">
          <el-input type="password" v-model="modifyPassword.form.confirmPwd" placeholder="确认新密码"/>
        </el-form-item>
        <el-form-item>
          <div style="text-align: center">
            <el-button type="primary" class="login-register-button-style" :disabled="modifyPassword.isCommitting" @click="submitModifyPassword">提交修改</el-button>
            <el-button type="default" @click="resetModifyPassword">重置表单</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div></div>
    </el-dialog>
  </div>
</template>

<script>
import deviceUtils from './util/deviceUtils'
import {mapActions} from 'vuex'
import {on} from 'element-ui/lib/utils/dom'
import browserUtils from './util/browserUtils'

export default {
  name: 'App',
  data () {
    return {
      primaryColor: '',
      lightColor: '',
      passwordExpirationInfo: {
        passwordExpireType: 'normal'
      },
      modifyPassword: {
        isCommitting: false,
        form: {
          oldPwd: '',
          newPwd: '',
          confirmPwd: ''
        },
        rules: {
          oldPwd: [{
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }],
          newPwd: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }, {
            validator: (rule, value, callback) => {
              let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[0-9A-Za-z]{8,20}$/
              if (regex.test(value)) {
                callback()
              } else {
                callback(new Error('密码需包含大小写字母和数字，长度8-20位'))
              }
            },
            trigger: 'blur'
          }],
          confirmPwd: [{
            required: true,
            message: '请再次输入新密码',
            trigger: 'blur'
          }]
        }
      }
    }
  },
  computed: {
    platformType: function () {
      return 'platform-' + deviceUtils.getDeviceType().toLowerCase()
    }
  },
  provide () {
    return {
      checkPasswordExpirationInfo: this.checkPasswordExpirationInfo
    }
  },
  methods: {
    ...mapActions(['loadUserAuthorize']),
    querySchoolName () {
      this.$ajax({
        url: '/index/baseSchool/getSchoolName',
        methods: 'post'
      }).then(response => {
        if (response.data) {
          if (response.data['responseCode'] === 'SUCCESS') {
            document.title = response.data['schoolName'] + ' -- 研究生招生报名系统管理后台'
            this.primaryColor = response.data['primaryColor']
            this.lightColor = response.data['lightColor']
            this.$store.commit('getSchoolInfo', {schoolName: response.data['schoolName']})
          }
        }
      })
    },
    checkPasswordExpirationInfo (data) {
      this.passwordExpirationInfo = data['passwordExpirationInfo'] || {}
    },
    submitModifyPassword () {
      let modifyPasswordForm = this.$refs['modifyPasswordForm']
      modifyPasswordForm.validate((valid) => {
        if (valid) {
          if (this.modifyPassword.form.newPwd === this.modifyPassword.form.oldPwd) {
            this.$message.error({
              message: '新密码不能与旧密码相同',
              center: true
            })
            return
          }
          if (this.modifyPassword.form.confirmPwd !== this.modifyPassword.form.newPwd) {
            this.$message.error({
              message: '确认密码与新密码不一致',
              center: true
            })
            return
          }
          const oldPwd = this.$md5(this.modifyPassword.form.oldPwd)
          const newPwd = this.$md5(this.modifyPassword.form.newPwd)
          // 修改密码
          this.modifyPassword.isCommitting = true
          this.$ajax({
            url: '/index/homeIndex/modifyPassword',
            method: 'post',
            data: this.$qs.stringify({
              oldPwd: oldPwd,
              newPwd: newPwd
            }),
            disableErrorPage: true
          }).then((response) => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message({
                    message: response.data['message'],
                    type: 'success',
                    center: true
                  })
                  this.resetModifyPassword()
                  this.passwordExpirationInfo.passwordExpireType = 'normal'
                  break
                }
                default: {
                  this.$message({
                    message: response.data['message'],
                    type: 'warning',
                    center: true
                  })
                  break
                }
              }
            }
          }, () => {
            this.$message.error({
              message: '请求发送失败，请稍后重试',
              center: true
            })
          }).finally(() => {
            this.modifyPassword.isCommitting = false
          })
        }
      })
    },
    resetModifyPassword () {
      let modifyPasswordForm = this.$refs['modifyPasswordForm']
      modifyPasswordForm.resetFields()
      this.$nextTick(() => {
        modifyPasswordForm.clearValidate()
      })
    }
  },
  created () {
    this.loadUserAuthorize().then(result => { this.checkPasswordExpirationInfo(result) }, () => {})
  },
  mounted () {
    /* ie下部分路由不跳转修复 */
    if (browserUtils.isIE()) {
      on(window, 'hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath)
        }
      })
    }
    this.querySchoolName()
  }
}
</script>

<style lang="scss">
  /* 引入样式 */
  @import "styles/index";
  @import "styles/indexIcon";
  #app {
    width: 100%;
    height: 100%;
    @include execute(var(--primaryColor), var(--lightColor))
  }
</style>



// WEBPACK FOOTER //
// src/App.vue